module.exports = __webpack_public_path__ + "static/media/canvas.1d6804a6.png";